import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCheck } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

export const ProblemReports = () => {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/problem-reports").then((r) => setRows(r.data || [])).catch(() => toast.error("Falha ao carregar relatos"));
  useEffect(() => { load(); }, []);
  const toggle = async (p) => { await api.patch(`/admin/problem-reports/${p.id}`, { status: p.status === "novo" ? "resolvido" : "novo" }); load(); };
  if (!rows) return null;
  if (!rows.length) return <p className="text-sm text-slate-500 p-4 text-center" data-testid="problems-empty">Nenhum problema relatado pelas escolas.</p>;
  return (
    <div className="space-y-2" data-testid="problems-list">
      {rows.map((p) => (
        <div key={p.id} className={`rounded-xl border p-3 bg-white ${p.status === "novo" ? "border-amber-300" : "border-slate-200 opacity-70"}`} data-testid={`problem-${p.id}`}>
          <div className="flex items-start justify-between gap-2">
            <p className="font-black text-slate-900 text-sm min-w-0">{p.school_name} <span className="font-semibold text-slate-500">· {p.user_name}</span></p>
            <span className={`shrink-0 text-[10px] font-black uppercase px-2 py-0.5 rounded-full ${p.status === "novo" ? "bg-amber-100 text-amber-800" : "bg-slate-100 text-slate-500"}`}>{p.status}</span>
          </div>
          <p className="text-[13px] text-slate-700 mt-1 whitespace-pre-line">{p.message}</p>
          <p className="text-[11px] text-slate-500 mt-1">{fmt(p.created_at)} · tela {p.page || "—"} · {p.user_email}</p>
          <button type="button" onClick={() => toggle(p)} data-testid={`problem-toggle-${p.id}`} className="mt-2 h-8 px-3 rounded-lg border border-slate-200 text-[12px] font-bold inline-flex items-center gap-1">
            <CheckCheck className="w-3.5 h-3.5" /> {p.status === "novo" ? "Marcar resolvido" : "Reabrir"}
          </button>
        </div>
      ))}
    </div>
  );
};
